import axios from "axios";

export class ReportingPermissionDataService {

    postReportPermission = (data) => {
        return axios.post("api/reporting/permission", JSON.stringify(data))
    };

    putReportPermission = (data) => {
        return axios.put("api/reporting/permission", JSON.stringify(data))
    };

    patchReportPermission = (data) => {
        return axios.patch("api/reporting/permission", JSON.stringify(data))
    };

    deleteReportPermission = (id, statusId) => {
        return axios.delete("api/reporting/permission/" + id + "/" + statusId)
    };

    getReportPermisionDetails = (permissionId) => {
        return axios.get("api/reporting/permission/" + permissionId)
    };

    getReportPremission = (queryStr) => {
        return axios.get(`api/reporting/permission?${`$count=true&`}${queryStr}`);
    };

    getReportPermissionForExcel = (queryString) => {
        return axios.get(`/api/reporting/permissionexcel?${queryString}`)
    };

    getUserType = () => {
        return axios.get(`api/accounts/usertype`);
    }
}

export default new ReportingPermissionDataService();